export default __webpack_public_path__ + "static/media/pakrap-8.dad3538d.mp3";